import AccountService from '@/services/AccountService'
import ParticipantService from "@/services/ParticipantService"
import RoomService from '@/services/RoomService'

export default {
  namespaced: true,
  state: {
    executiveAccounts: null,
    executiveAccountStatus: null,
    accounts: null,
    conferenceHistory: null,
    lockedRMParties: null,
    participants: null,
  },
  mutations: {
    saveExecutiveAccounts(state, data) {
      state.executiveAccounts = data
    },
    saveAccounts(state, accounts) {
      state.accounts = [...accounts]
    },
    saveAccount(state, accountData) {
      const index = state.accounts.findIndex(account => account._id == accountData._id)
      if(index > -1) {
        state.accounts[index] = {...accountData}
      } else {
        state.accounts.push(accountData)
      }
    },
    saveConferenceHistory(state, data) {
      state.conferenceHistory = data
    },
    saveExecutiveRoomAccountStatus(state, data) {
      state.executiveAccountStatus = data
    },
    saveParticipants(state, { newParticipants, username }) {
      const newParticipantsData = newParticipants&&newParticipants.map(participant => {
        const { disabled, email, entityTag, firstName, lastName, locked, name } = participant
        return {
          disabled: disabled[0],
          email: email[0],
          entityTag: entityTag[0],
          firstName: firstName[0],
          lastName: lastName[0],
          locked: locked[0],
          name: name[0]
        }
      })||[]
      if (!state.participants) state.participants = {};
      state.participants[username] = []
      state.participants = {
        ...state.participants,
        [username]: newParticipantsData
      }
    },
    updateParticipantStatus (state, { newParticipant, userOwner }) {
      state.participants = {
        ...state.participants,
        [userOwner]: [newParticipant, ...(state.participants&&state.participants[userOwner]&&state.participants[userOwner].filter(user => user.name !== newParticipant.name)||[])]
      }
    },
    removeAccount(state, accountData) {
      state.accounts.splice(accountData, 1);
    },
    resetParticipantListAtAdmin(state) {
      state.participants = null
    },
    deleteMultiUserByAdmin (state, data) {
      if (state.participants) {
        state.participants = {
          ...state.participants,
          [data.owner]: state.participants[data.owner].filter(user => {
            return data.participants.every(party => {
              return party.name !== user.name
            })
          })
        }
      }
    },
    saveLockedParties(state, data) {
      state.lockedRMParties = data
    }
  },
  actions: {
    async fetchAccountList({ commit, rootState }) {
      const token = rootState.auth.token
      const username = rootState.auth.username
      try {
        const res = await AccountService.fetchAccountList({ username }, token);
        if (res.data.status) {
          commit('saveAccounts', res.data.users)
        }
        return res
      } catch (err) {
        throw new Error(err)
      }
    },
    async updateAccount({ commit, rootState }, account) {
      const token = rootState.auth.token
      try {
        const res = await AccountService.updateAccount(account, token)
        if (res.data.status) {
          commit('saveAccount', {...res.data.users, ...account})
        }
        return res
      } catch (err) {
        throw new Error(err)
      }
    },
    deleteParticipantsByAdmin({commit, rootState}, params) {
      const token = rootState.auth.token
      return AccountService.deleteMultiParticipants(params, token).then((res) => {
        if (res.data.status) {
          commit('deleteMultiUserByAdmin', {participants: params.participants, owner: params.owner})
        }
        return res;
      }).catch((err) => {
        throw new Error(err)
      })
    },
    async deleteAccount({ commit, rootState }, account) {
      const token = rootState.auth.token
      try {
        const res = await AccountService.deleteAccount(account, token);
        if (res.data.status) {
          commit('removeAccount', res.data.user)
        }
        return res
      } catch (err) {
        throw new Error(err)
      }
    },
    disableParticipantWithOwner ({ commit, rootState, state }, data) {
      const {user, userOwner} = data
      const token = rootState.auth.token
      return ParticipantService.disableParticipant({ user }, token).then(() => {
        commit('updateParticipantStatus', {newParticipant: user, userOwner})
        return state.participants;
      }).catch((err) => {
        throw new Error(err)
      })
    },
    async exportConferenceHistory({ rootState }, data) {
      const owner = rootState.auth.username
      const token = rootState.auth.token
      return await AccountService.exportConferenceLog({ owner, ...data }, token)
    },
    getAllParticipants({ rootState }, owners) {
      return AccountService.fetchAllParticipants({owners}, rootState.auth.token)
    },
    getConferenceHistory({ rootState, commit }) {
      return AccountService
      .getConferenceHistory({owners: rootState.auth.username}, rootState.auth.token)
      .then((res) => {
        commit('saveConferenceHistory', res.data.data)
        return res
      })
    },
    async getExecutiveAccounts({ commit, rootState }) {
      const token = rootState.auth.token
      const docs = await AccountService.getExecutiveAccounts(token)
      if(docs.data.status) {
        commit('saveExecutiveAccounts', docs.data.data)
      }
      return docs.data
    },
    async getExecutiveRooms({ rootState }) {
      const token = rootState.auth.token
      const docs = await RoomService.getConferenceIDList({
        owner: rootState.auth.username
      }, token)
      return docs.data.conferences
    },
    async getExecutiveAccountStatus({ rootState, commit }) {
      const token = rootState.auth.token
      const docs = await AccountService.getExecutiveAccountStatus(token)
      if(docs.data.status) {
        commit('saveExecutiveRoomAccountStatus', docs.data.data)
      }
      return docs.data
    },
    async getParticipantsWithUsername({ commit, rootState }, username) {
      const token = rootState.auth.token
      try {
        const res = await AccountService.fetchParticipantWithUserName({ username }, token);
        if (res.data) {
          commit('saveParticipants', { newParticipants: res.data.participants, username })
        }
        return res
      } catch (err) {
        throw new Error(err)
      }
    },
    async getLockedRMParties({commit, rootState}) {
      const token = rootState.auth.token
      try {
        const res = await AccountService.getLockedRMParties(token)
        commit('saveLockedParties', res.data.parties)
        return res
      } catch (err) {
        throw new Error(err)
      }
    },
    async searchParties ({ commit, rootState }, params) {
      const token = rootState.auth.token
      const owner = params.owner
      const searchName = params.searchName
      try {
        const res = await AccountService.searchParticipantWithUserName({ owner, searchName }, token)
        commit('saveParticipants', {newParticipants: res.data.participants, username: owner})
        return res;
      } catch (err) {
        throw new Error(err)
      }
    },
    async setExecutiveAccountStatus({ rootState }, params) {
      const token = rootState.auth.token
      const docs = await AccountService.setExecutiveAccountStatus(params, token)
      return docs.data
    },
    async unlockRMParty({rootState}, params) {
      const token = rootState.auth.token
      try {
        const res = await AccountService.unlockRMParty(params, token)
        return res
      } catch (err) {
        throw new Error(err)
      }
    },
    updatePWAccount({rootState}, account) {
      return AccountService.changePassAccount(account, rootState.auth.token)
    },
  }
}